<script>
import { initiatePasswordReset } from '../services/userService'

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      userForm: {},
      errors: { email: null },
      emailSent: false
    }
  },
  methods: {
    async initiatePasswordReset() {
      try {
        if (this.userForm.email.length === 0) {
          this.errors = {
            email: 'Enter your email address.',
            password: null
          }
          return
        }

        const passwordResetData = await initiatePasswordReset(this.userForm)

        if (passwordResetData) {
          this.errors = { email: null }
          this.emailSent = true
        }
      } catch (error) {
        switch (error.message) {
          case 'GraphQL error: Email does not exist':
            this.errors = {
              email: "We couldn't find an account with this email."
            }
            break
          case 'GraphQL error: Failed to send password reset email':
            this.errors = {
              email:
                'Failed to send password reset email. Please try again later.'
            }
            break

          default:
            break
        }
      }
    }
  }
}
</script>

<template>
  <div class="container section">
    <div class="columns">
      <div class="column is-offset-3 is-6">
        <div class="illustration">
          <img src="@/assets/img/illustrations/sign-in-2.png" alt="Login" />
        </div>

        <div v-if="!emailSent">
          <h2 class="title is-3 is-spaced has-text-centered">
            Find your account
          </h2>
          <b-field
            :type="{ 'is-danger': !!errors.email }"
            :message="errors.email"
            label="Email"
          >
            <b-input
              v-model="userForm.email"
              type="email"
              placeholder="Email"
            />
          </b-field>
          <div class="column is-pulled-right">
            <button
              class="button is-rounded is-secondary"
              @click="initiatePasswordReset"
            >
              Send me reset link
            </button>
          </div>
        </div>

        <div v-if="emailSent">
          <h2 class="title is-3 is-spaced has-text-centered">
            Check your email
          </h2>
          <div class="subtitle is-4">
            We've sent an email to
            <strong>{{ userForm.email }}</strong>
            . Click the link in the email to reset your password.
          </div>
          <div class="subtitle">
            If you don't see the email, check other places it might be, like
            your junk, spam, social or other folders.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.is-vertical-center
  align-items: center
  margin-top: 13vw

.field, button, h1
  margin-bottom: 20px

.illustration
  padding: 50px 0 25px
  text-align: center
  img
    max-height: 200px
</style>
